export const filterPageSections = (pageSections = []) => {
  return pageSections.filter((pageSection = {}) => {
    let isVisible = true;
    const dependPageSectionName = pageSection.depend_page_section;
    const dependFieldDefinitionName = pageSection.depend_field_definition;
    const dependFieldValue = pageSection.depend_field_value;

    if (dependPageSectionName && dependFieldDefinitionName && dependFieldValue) {
      const dependPageSection = pageSections.find(
        (page = {}) => page.slug === dependPageSectionName
      );
      if (dependPageSection) {
        const fieldDefinitions = dependPageSection.field_definition || [];
        const dependFieldDefinition = fieldDefinitions.find(
          (definition = {}) => definition.slug === dependFieldDefinitionName
        );
        if (dependFieldDefinition) {
          isVisible = dependFieldDefinition.field_value === dependFieldValue;
        }
      }
    }
    return isVisible;
  });
};
